import { TeamCard } from '../../../../../features/team/components/TeamCard';
import { useI18n } from '../../../../../shared/i18n';
import { useData } from '../../../../../shared/lib';
import { Container, EmptyState, Eyebrow, Grid, Section } from '../../../../../shared/ui';
import type { TeamListingData } from './+data';

export default function Page() {
  const { t } = useI18n();
  const { members, photos } = useData<TeamListingData>();

  return (
    <Section spacing="lg">
      <Container className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          {/* A route, not a translated label — see the same choice on the
              other listings. */}
          <Eyebrow>
            <span dir="ltr">/team</span>
          </Eyebrow>
          <h1 className="max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl">
            {t('nav.primary.team')}
          </h1>
        </div>

        {members.length > 0 ? (
          // No panel behind the grid: the cards sit on the page's own black
          // and let the 0/1 field through, same as `/services`.
          <Grid columns={4}>
            {members.map((member) => (
              <TeamCard
                key={member.id}
                member={member}
                photo={member.photo_media_id ? photos[member.photo_media_id] : undefined}
              />
            ))}
          </Grid>
        ) : (
          <EmptyState
            title={t('common.team.emptyTitle')}
            description={t('common.team.emptyDescription')}
          />
        )}
      </Container>
    </Section>
  );
}
